// extracted by mini-css-extract-plugin
export var container = "style-module--container--bdb7a";
export var link = "style-module--link--2ca7e";
export var rule = "style-module--rule--fb6d1";